import React, { useEffect, useState } from "react";
import { Paper, Typography, Tabs, Tab } from "@mui/material";
import httpClient from '../../_util/api'
import AttachmentsList from "../AttachmentList";
import Timeline from "../TimeLine";

const allUsers = [
  { id: 1, status: "Pending", attachment: "file1.pdf", notes: "Waiting for approval" },
  { id: 2, status: "Approved", attachment: "file2.pdf", notes: "Approved by admin" },
  { id: 3, status: "Rejected", attachment: "file3.pdf", notes: "Missing information" },
  { id: 4, status: "Pending", attachment: "file4.pdf", notes: "Under review" },
];

const NotesComponent = () => (
  <Paper sx={{ padding: 2 }}>
    <Typography variant="h6">Notes</Typography>
    {allUsers.map(user => (
      <Typography key={user.id}>{user.notes}</Typography>
    ))}
  </Paper>
);

const ApplicationDetails = ({ CNICNo }) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [attachments, setAttachments] = useState([]);
  const [timelines, setTimelines] = useState([]);
  const getAllAttachmentsByCNICNo = async () => {
    const res = await httpClient.get(`/students/getAllAttachmentsByCNICNo/${CNICNo}`).catch((error) => {
    })

    if (res?.status === 200) {
        const attachmentsData = res.data.attachmentsArray;
        setAttachments(attachmentsData);
    }
  }

    const getTimelines = async () => {
        const res = await httpClient.get(`/timelines/getTimelinesByMonth_StudentView`);
        if (res?.status === 200) {
          setTimelines(res?.data)
        }
    }

  useEffect(()=> {
    getAllAttachmentsByCNICNo();
    getTimelines();
  }, [])

  return (
    <div>
      <Tabs value={tabIndex} onChange={(e, newIndex) => setTabIndex(newIndex)} sx={{ marginBottom: 2 }}>
        <Tab label="Status" />
        <Tab label="Attachments" />
        <Tab label="Notes" />
      </Tabs>
      {tabIndex === 0 && <Timeline/>}
      {tabIndex === 1 && <AttachmentsList files={attachments[0]?.files}/>}
      {tabIndex === 2 && <NotesComponent />}
    </div>
  );
};

export default ApplicationDetails;